import type { JSX } from 'react';

import { NoteTypes } from '~constants/enums';
import { Notes } from '~formsShared/components/Notes';

import { useProjectFormV2Context } from '../ProjectFormV2Context';

// Mirrors the legacy form — a render-only wrapper around the
// existing `<Notes/>` shared widget. `<Notes/>` already calls
// `useFormContext()` internally so the Provider's FormProvider is the only
// wiring required. `defaultProject` flows in through context (set by the
// Provider from the dialog's `defaultProject` prop). Do NOT fork
// `<Notes/>` — this panel's contract is "wrapper only".
export function NotesPanel(): JSX.Element {
  const { defaultProject } = useProjectFormV2Context();
  return <Notes defaultData={defaultProject} defaultTab={NoteTypes.PROJECT} />;
}
